import type { CoreExtraContext } from "@segment/analytics-core";

import { UAParser } from "ua-parser-js";

const MOBILE_DEVICE_TYPES = ["mobile", "tablet", "wearable"];
const UNKNOWN_VALUE = "unknown";

/**
 * Segment-compatible userAgentData structure extracted from @segment/analytics-core
 * @see https://www.twilio.com/docs/segment/connections/spec/common
 */
type UserAgentData = NonNullable<CoreExtraContext["userAgentData"]>;

/**
 * Get userAgentData fallback for browsers without native Client Hints API support.
 */
function getUserAgentDataFallback(): UserAgentData | undefined {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return undefined;
  }

  const { browser, device, os } = UAParser(navigator.userAgent);

  return {
    brands: [
      {
        brand: browser.name ?? UNKNOWN_VALUE,
        version:
          browser?.version?.split(".")[0] ?? browser.version ?? UNKNOWN_VALUE,
      },
    ],
    mobile: MOBILE_DEVICE_TYPES.includes(device.type ?? ""),
    platform: os.name ?? UNKNOWN_VALUE,
  };
}

export { getUserAgentDataFallback };
